import IndexRedirect from './IndexRedirect';

export default IndexRedirect;
